<template>
  <article @click="openSearchBar" class="hotel-card" data-testid="hotel-card">
    <img
      class="img-responsive hotel-card__logo"
      crossorigin="anonymous"
      :src="`${brandLogosUrl}/${hotel.brand}.svg`"
      :alt="`${hotel.brand} logo`"
    />
    <section class="hotel-card__body">
      <div class="hotel-card__title">
        <h3>
          <strong>{{ hotel.name }}</strong>
        </h3>
        <a @click="openHotelPage" id="see-the-hotel-page-link" :href="hotel.overviewPath" class="btn btn-link">{{translate('offSeeHotelPage')}}</a>
      </div>
      <div class="hotel-card__price">
        <p>
          {{ translate('weFrom') }}<br />
          <span data-testid="hotel-card-price">{{
            hotel.priceFrom
              ? hotel.priceFrom.amount === 0
                ? translate('offMapSoldOut')
                : hotel.priceFrom.formattedAmount
              : translate('desLoading')
          }}</span>
        </p>
        <button data-testid="hotel-card-span" class="btn btn-link">
          <i class="icon-arrow-right xs red"></i>
        </button>
      </div>
    </section>
  </article>
</template>

<script>
import { assetsUrl } from '@/infrastructure/Configuration'

export default {
  name: 'HotelCard',
  props: {
    hotel: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    brandLogosUrl: `${assetsUrl}/img/logos/rounded`
  }),
  methods: {
    openSearchBar(event) {
      if (this.hotel.priceFrom.amount !== 0) {
        global.showOfferCalendarByHotel(this.hotel.code)
      }
    },
    openHotelPage(event) {
      event.stopPropagation()
    }
  }
}
</script>

<style scoped lang="scss">
.hotel-card {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 2rem 1.6rem;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d8d8d8;
  border-radius: 1rem;

  @media (min-width: 576px) {
    margin-right: 1.8rem;
  }

  &__logo {
    width: 4rem;
    height: 4rem;
    margin-right: 0.8rem;

    @media (min-width: 576px) {
      margin-right: 1.8rem;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    @media (min-width: 576px) {
      flex-direction: row;
    }
  }

  &__title {
    flex-grow: 1;
    margin-bottom: 1.6rem;

    h3 {
      font-weight: 300;
      font-size: 1.4rem;
      line-height: 1.8rem;
      color: color('black');
    }

    .btn-link {
      font-weight: 400;
      font-size: 1rem;
      text-decoration: underline;
      color: #53565a;
    }

    @media (min-width: 576px) {
      margin-bottom: 0rem;
    }
  }

  &__price {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-grow: 1;

    p {
      margin: 0;
      font-weight: 400;
      font-size: 1.2rem;
      text-align: left;
      color: #53565a;
      margin-right: 3.6rem;

      span {
        font-weight: 800;
        font-size: 1.8rem;
        color: color('black');

        @media (min-width: 576px) {
          font-size: 1.6rem;
        }
      }

      @media (min-width: 576px) {
        text-align: right;
        font-size: 1rem;
      }
    }

    @media (min-width: 576px) {
      flex-grow: 0;
    }
  }
}
</style>
